/* src/app/shared/components/flow-accordion-container/flow-accordion/flow-accordion.component.scss */
.accordion-header {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  width: 100%;
}
.accordion-header .arrow-img {
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  min-height: 20px !important;
  cursor: pointer;
  filter: brightness(0) saturate(100%) invert(45%) sepia(10%) saturate(279%) hue-rotate(202deg) brightness(95%) contrast(85%);
}
.divider {
  height: 1px;
  width: 100%;
  background-color: #d4d4d8;
}
.accordion-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 12px;
  width: 100%;
}
/*# sourceMappingURL=flow-accordion.component.css.map */
